import { Flex, Text } from '@chakra-ui/react';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OutlineCard } from '@morressier/alembic';
import { IGetSubmissionUnsubmitResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import MultilineText from 'src/components/MultilineText';
import { formatDate } from 'src/utils/date';
import { EditorialAttachments } from './EditorialAttachments';

export const UnsubmitFeedback = ({
  data,
  dateEntered,
  submissionContextId
}: {
  data: IGetSubmissionUnsubmitResponse;
  dateEntered: string;
  submissionContextId: string;
}) => {
  const { attachments, editorComment } = data || {};

  return (
    <OutlineCard padding={4} width="100%">
      <Flex flexDirection="column" gap={6}>
        <Text textStyle="headingSection">
          Submission Unsubmitted by Editors
        </Text>

        <Flex flexDirection="column" gap={2}>
          <Flex flexDirection="row" gap={2} alignItems="center">
            <FontAwesomeIcon icon={faCalendar} />
            Received {formatDate(new Date(dateEntered))}
          </Flex>
        </Flex>

        {editorComment && (
          <Flex gap={2} flexDirection={'column'}>
            <Text textStyle="headingGroup">Editor’s Response</Text>
            <MultilineText textStyle="textBody" text={editorComment} />
          </Flex>
        )}

        <EditorialAttachments attachments={attachments} submissionContextId={submissionContextId} />
      </Flex>
    </OutlineCard>
  );
};
